import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { set_current_generation } from '@/utils/utils_client_workspace_child_entity_viewers';

export function WATCHER__select_created_user_task() {
  const { user_tasks_map } = use_slice_generation(['user_tasks_map']);
  const { page_tasks_new_task_id } = use_slice_ui(['page_tasks_new_task_id']);

  use_effect(() => {
    if (page_tasks_new_task_id.is_empty_object_id()) return;

    let user_task = user_tasks_map.get(page_tasks_new_task_id);
    if (!user_task) return;

    let most_recent_generation = user_task.getMostRecentGeneration();
    void set_current_generation(most_recent_generation._id);

    //dont reset paget_tasks_new_task_id here, we should use it on input
  }, [page_tasks_new_task_id, user_tasks_map]);

  return null;
}
